import axiosReq from "../utils/axiosReq";
import axios from 'axios';
import { useUserStore } from '@/framework/store/user';
import { downloadFile } from "./base_const.js"
/*
 *电子电气零部件
 */
const baseApi =
    import.meta.env.VITE_APP_NODE_ENV == 'development' ? "/OpenApiPrefix/api" : '/api';

export const thirdPartyListHttptUrl = `${baseApi}/board/v1/mgmt/third-part-company/list`//第三方管理公司列表
export const subCompanyListHttpUrl = `${baseApi}/board/v1/mgmt/third-part-company/list-of-subsidiaries` //第三方管理公司列表
export const thirdPartyTruckListUrl = `${baseApi}/board/v1/mgmt/third-part-company-truck/list` //第三方管理的公司的车辆列表
export const getFinanceTruckListHttpUrl = `${baseApi}/board/v1/mgmt/financial-lock/list` //金融锁车车辆列表
export const getSmsCommandListUrl = `${baseApi}/board/v1/mgmt/financial-lock/commands` //短信指令列表 
export const financialLockOrderListHttpUrl = `${baseApi}/board/v1/mgmt/financial-lock/finance-lock-order-list` //订单列表
export const remoteControlRecordListHttpUrl= `${baseApi}/board/v1/mgmt/statistics/remote/operation` //远控操作记录
export const remoteCommandMonthlyCountListHttpUrl= `${baseApi}/board/v1/mgmt/statistics/remote/month` //远控命令执行月统计
export const remindRateListHttpUrl=`${baseApi}/board/v1/carmachine/behavior/getEconomyRemindExecReport` //提醒执行率列表
export const dayDriverBehaviorListHttpUrl=`${baseApi}/board/v1/mgmt/getDayTripDetailForWeb` //驾驶行为分析列表
export const badDriveBehaviorQuantityListHttpUrl=`${baseApi}/board/v1/mgmt/getBadDriveBehaviorQuantity` //获取驾驶行为评分判断值



//查询第三方公司详情
export function getThirdPartyCompanyDetailHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/third-part-company/detail/${id}`,
        method: 'get',
    });
}

// addThirdPartCompany(param) {
//     return axios.post('board/v1/mgmt/third-part-company/add', param);
// },
//添加第三方公司的信息
export function addThirdPartyCompanyHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/third-part-company/add`,
        method: 'post',
        data
    });
}
//更新第三方公司的信息
export function updateThirdPartyCompanyHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/third-part-company/modify`,
        method: 'put',
        data
    });
}

//添加第三方公司的车辆信息
export function addThirdPartyTruckHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/third-part-company-truck/add`,
        method: 'post',
        data
    });
}

//添加第三方公司的车辆信息
export function deleteThirdPartyTruckHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/third-part-company-truck/delete/${id}`,
        method: 'delete'
    });
}
//更新第三方公司的车辆信息
export function updateThirdPartyTruckHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/third-part-company-truck/modify`,
        method: 'put',
        data
    });
}

/**
 * 查询发动机号列表
 * @param {*} vin 
 * @returns 
 */
export function getFinanceTruckEngineCodesHttpReq(vinList) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck/batchGetEngineCertificateTruckByVinCodeList`,
        method: 'post',
        data: {
            vinList: vinList
        }
    });
}
/**
 * 查询单个发动机号
 * @param {*} vin 
 * @returns 
 */
export function getFinanceTruckEngineCodeHttpReq(vin) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck/selectImportTruckList?vin=${vin}`,
        method: 'get',
    });
}
//根据关键字查询车队列表
export function queryFleetListHttpReq(keywords) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/query-fleet-name?s=${keywords}`,
        method: 'get',
    });
}
//执行短信指令
export function financialSmsCommandHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/executeMessage`,
        method: 'post',
        data
    });
}

//锁车状态获取
export function financialLockStateHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/execute`,
        method: 'post',
        data
    });
}

/**
    * 更新车辆状态
    * @param vin
    * @returns {AxiosPromise<any>}
    */
export function updateStatusHttpReq(vin) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/detail?vin=${vin}`,
        method: 'get',
    });
}

/**
    * 查询指令执行结果
    * @param commandId
    * @returns {AxiosPromise<any>}
    */
export function getCommandReultHttpReq(commandId) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/record?commandRecordId=${commandId}`,
        method: 'get',
    });
}

/**
 * 确认收款
 */

export function confirmCollectionHttpReq(data) {
    // https://mgmt.sanytruck.com/vd/sanymgmt/board/v1/mgmt/financial-lock/finance-lock-order-list?bu
    // https://mgmt.sanytruck.com/vd/sanymgmt/sany/dms/v1/financial-lock/confirm-collection?request_no=1720404125270
    return axiosReq({
        url: `${baseApi}/sany/dms/v1/financial-lock/confirm-collection`,
        method: 'post',
        data
    });
}


/**
 * 申请开票
 */

export function applyInvoiceHttpReq(data) {
    // https://mgmt.sanytruck.com/vd/sanymgmt/board/v1/mgmt/financial-lock/finance-lock-order-list?bu
    // https://mgmt.sanytruck.com/vd/sanymgmt/sany/dms/v1/financial-lock/confirm-collection?request_no=1720404125270
    return axiosReq({
        url: `${baseApi}/sany/dms/v1/financial-lock/apply-invoice`,
        method: 'post',
        data
    });
}
/**
 * 
 *获取开票公司信息
 * @returns 
 */
export function queryInvoiceInfoHttpReq(id) {
    return axiosReq({
        url: `${baseApi}/sany/dms/v1/financial-lock/queryInvoices/${id}`,
        method: 'get',

    });
}

/**
 * 车辆上线提醒/取消上线提醒
 */

export function onlineRemindHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/truck/online-remind`,
        method: 'put',
        data
    });
}
/**
 * 更新车辆状态
 */
export function updateTruckStatusHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/execute`,
        method: 'post',
        data
    });
}
/**
 * 紧急解锁动作查询
 * @param {*} mileage 
 * @returns 
 */
export function emergencyUnlockParamQueryHttpReq(mileage) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/emergency-unlock-param?mileage=${mileage}`,
        method: 'get',

    });
}

/**
 * 批量下发指令
 */
export function batchExecuteVehicleHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/executeList`,
        method: 'post',
        data
    });
}

// return axios.post('board/v1/mgmt/financial-lock/executeList', param);

/**
 * 获取批量导入模板
 * @param {*} companyTruckId
 * @returns
 */
export function getOrderBatchImportTemplate() {
    const { access_token, userInfo } = useUserStore();
    const myAxiosReq = axios.create({
        headers: {
            Authorization: `Bearer ${access_token}`,
            account_id: userInfo?.accountId
        }
    })
    return myAxiosReq
        // .post(`${baseApi}/board/v1/mgmt/financial-lock/financial-lock-Installment/export?request_no = ${new Date().getTime()}`,null, {
        //     responseType: 'blob'
        // })
        .get(`${baseApi}/board/v1/mgmt/financial-lock/financial-lock-Installment/export?request_no = ${new Date().getTime()}`, {
            responseType: 'blob'
        })
        .then(({ headers, data }) => {
            let contentType = headers['content-type'];
            let fileName =
                decodeURI(
                    headers['content-disposition'].split('filename=')?.[1]
                ) || null;
            downloadFile(data, contentType, fileName);
        });
}

/**
     * 查询业务监控统计数据
     * @returns {AxiosPromise<any>}
     */
export function getMonitorSummaryHttpReq() {
    // return axios.get('board/v1/mgmt/financial-lock/summary');
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/summary`,
        method: 'get',
    });
}

/**
    * 查询业务监控数据
    */
export function getFinancilLockMonitorHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/monitor`,
        method: 'get',
        data,
        isParams: true,
    });
}

/**
   * 查询业务监控单车详细数据
   * @param vin
   */
export function getFinancilLockMonitorCarDetailHttpReq(vin) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/monitor/vehicle?vin=${vin}`,
        method: 'get',
    });
}

/**
 * 短信预警
 */
export function businessMonitorRemindHttpReq(vin){
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/financial-lock/truck/business-monitor-remind?vin=${vin}`,
        method: 'put',
    });
}


/**
 * 远程命令执行统计
 */
export function getRemoteCommandSummaryHttpReq(vin) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/statistics/remote/summary`,
        method: 'get',
    });
}


/**
 * 驾驶行为 提醒执行率统计
 */

export function getRemindRateHttpReq() {
    return axiosReq({
        url: `${baseApi}/board/v1/carmachine/behavior/getNationalEconomyRemindExec`,
        method: 'get',
    });
}



//获取驾驶行为权重
export function getTruckDriveBehaviorWeightHttpReq() {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/getTruckDriveBehaviorWeight`,
        method: 'get',
    });
}

//
export function getDriveBehaviorMaxNumHttpReq() {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/getDriveBehaviorMaxNum`,
        method: 'get',
    });
}



/**
 * 驾驶行为分析-参数设置保存  (更新驾驶行为权重)
 */
export function saveTruckDriveBehaviorWeightHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/setTruckDriveBehaviorWeight`,
        method: 'post',
        data
    });
}



